const LOAN_FORM_KEY = "loanFormData";
const EARLY_LEAD_KEY = "applyFlowEarlyLeadId";
const PAN_DRAFT_KEY = "applyFlowPanDraft";
const STEP2_RESTORE_KEY = "applyFlowRestoreStep2Contact";

const AADHAAR_KEYS = [
  "aadhaarData",
  "aadhaarReferenceId",
  "aadhaarNumber",
  "aadhaar_mobile",
  "loanFormData",
  "currentLeadId",
  "mobile_otp",
  "mobile_verified",
  "mobileNumber",
  "pan_verified",
];

/** Step 2 → Step 1: clear Aadhaar and everything after it */
export const clearFromAadhaarStep = () => {
  AADHAAR_KEYS.forEach((key) => localStorage.removeItem(key));
  sessionStorage.removeItem(EARLY_LEAD_KEY);
  sessionStorage.removeItem(PAN_DRAFT_KEY);
  sessionStorage.removeItem(STEP2_RESTORE_KEY);
};

/** Step 3 → Step 2: restore mobile/email on return from loan form */
export const markStep2ContactRestore = () => {
  sessionStorage.setItem(STEP2_RESTORE_KEY, "1");
};

/** Step 1 → Step 2: fresh contact fields (no restore) */
export const clearStep2ContactRestore = () => {
  sessionStorage.removeItem(STEP2_RESTORE_KEY);
};

export const consumeStep2ContactRestore = () => {
  const shouldRestore = sessionStorage.getItem(STEP2_RESTORE_KEY) === "1";
  sessionStorage.removeItem(STEP2_RESTORE_KEY);
  return shouldRestore;
};

/** Step 3 → Step 2: keep contact data; persist loan step draft for return */
export const saveLoanStepDraft = ({ pan, panStatus, earlyLeadId }) => {
  if (pan) {
    sessionStorage.setItem(
      PAN_DRAFT_KEY,
      JSON.stringify({ pan, panStatus: panStatus || "" })
    );
  }

  if (earlyLeadId) {
    sessionStorage.setItem(EARLY_LEAD_KEY, String(earlyLeadId));
  }
};

export const getLoanStepDraft = () => {
  const panRaw = sessionStorage.getItem(PAN_DRAFT_KEY);
  const earlyLeadId = sessionStorage.getItem(EARLY_LEAD_KEY);

  return {
    panDraft: panRaw ? JSON.parse(panRaw) : null,
    earlyLeadId: earlyLeadId || null,
  };
};

export const hasCompletedStep2 = () => Boolean(localStorage.getItem(LOAN_FORM_KEY));

export const clearLoanStepDraft = () => {
  sessionStorage.removeItem(EARLY_LEAD_KEY);
  sessionStorage.removeItem(PAN_DRAFT_KEY);
};
